module.exports = "/images/Create packages - 4.jpg";